import React, { Component } from "react";
import axios from "axios";
import { apiUrl, apiUrl2, apiUrl3, apiUrl4 } from "../../config/config";
import classnames from "classnames";
import Select from "react-select";
import $ from "jquery";
import Modal from "react-modal";
import "./patientinfo.css";
import { MDBDataTable } from "mdbreact";
import ProgressBtn from "../../components/common/ProgressButton";
import TopNav from "../../components/common/TopNav";
import SideBar from "../../components/common/SideBar";
import Dropdown from "react-dropdown";
import "react-dropdown/style.css";
import LinearProgress from "@material-ui/core/LinearProgress";
import { FormatAlignLeft, Label } from "@material-ui/icons";
import { Toaster, toast } from "react-hot-toast";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
Modal.setAppElement("#root");

class PatientInfoWeb extends Component {
  constructor() {
    super();
      const menus = [
        { title: "Verifier Home", url: "/verifier-home" },
        { title: "Patient list", url: "/patient-list" },
        { title: "Labled Patients", url: "/labled-patients" },
        { title: "Verified", url: "/verification-completed" },
  
      ];
      if (localStorage.getItem("verifiertype") === "8") {
        menus.splice(2, 0, { title: "Patient-hold", url: "/patient-hold" });
      }
        if (localStorage.getItem("AdminUser") === "8") {
          menus.splice(3, 0, { title: "Device Deatils", url: "/device-details" });
          menus.splice(4, 0, { title: "Battery Issue", url: "/battery-issue" });
        }
  
      if (localStorage.getItem("verifiertype") === "8") {
        menus.splice(4, 0, { title: "Support Home", url: "/support-home" });
      }
      if (localStorage.getItem("verifiertype") === "8") {
        menus.splice(5, 0, { title: "QC Home", url: "/qc_home" });
      }
      if (localStorage.getItem("verifiertype") === "8") {
        menus.splice(6, 0, { title: "Support Web", url: "/support-homeweb" });
      }
      if (localStorage.getItem("AdminUser") === "8") {
        menus.splice(6, 0, { title: "Report Shared", url: "/report-shared" });
      }
      if (localStorage.getItem("AdminUser") === "8") {
        menus.splice(6, 0, {
          title: "Supported Person",
          url: "/supported-persons",
        });
       
        }
         if (localStorage.getItem("AdminUser") === "8") {
          menus.splice(6, 0, {
            title: "Reset Password",
            url: "/ResetPassword",
          });
      }
    this.state = {
      menus,
      profileLink: "verifier-profile",
      patients: [],
      serial_no: "",
      currentPage: 1,
      totalPages: 1,
      errors: {},
      userid: "",
      showCsvModal: false,
      csvParam1: "",
      csvParam2: "",

      hospital: "",
      ip_op: "",
      BatteryPercentage: "",
      backup: "",
      patient_name: "",
      phone: "",

      indication: "",

      doctors: [],
      doctor_id: "",
      doctor_name: "Choose",
      data: { rows: [] },
      prog_data: 0,
      loading: false,
      time: "",
      RecordingStatus: "",
      serial_no: "",
      device_id: "",
      Mac_id: "",
      customer_details: "",

      activity: "Rest",
      act_duration: "5",
      addNote: "",
      selectedDoctor: null,
      search: "",
      pageSize: 50,
      sortField: null,
      sortDirection: "asc",
      pacemaker: false,
      supportPersons: [], // list from API
      verifiers: [],
      selectedVerifierIds: [],
      selectedVerifiers: [],

      supportPerson: "", // selected support person id
      supportLevel: "",
      supportedMatter: "",
      Confirmation: "",
      filetype: "",
      dob: null,
      loadingEditModal: false, // Added loading state for edit modal
      data: {},
      prioritizeData: "No", // <-- Add this line for the new field
      clinicalCondition: "", // <-- Add this line for the new field
      triggerModalOpen: false,
      triggerType: "new",
      triggerUserId: "",
      triggerWeb: "",
      triggerPatientId: "",
      triggerOutput: null,
      triggerErrors: {},
      // socketNew: socketIOClient("http://edit.mybiocalculus.com:5000"),
    };
    this.selectItem = this.selectItem.bind(this);
    this.preventDefault = this.preventDefault.bind(this);
    this.fetchPatients = this.fetchPatients.bind(this);
    this.handleDoctorChange = this.handleDoctorChange.bind(this);
    // this.handlePageChange = this.handlePageChange.bind(this);
  }

  componentDidMount() {
    this.fetchData();
    this.fetchPatients(this.state.currentPage);
    function capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }
    var newstat = this;

    /*socket.on('connect', function(){console.log('connected')});
    socket.on('connect_error', function(err){console.log(err)});
    socket.on('data', function(data){


      newstat.setState({"loading":true});
      
      console.log(newstat.state.loading)
    });
    socket.on('disconnect', function(){console.log('disconnected')});*/
  }
  fetchData = () => {
    const verifiertype = localStorage.getItem("verifiertype");
    this.setState({ verifiertype });
    // Remove the Worker usage and fetch doctors directly with axios
    axios.get(apiUrl + "api/users/alldoctors").then((res) => {
      this.setState({ doctors: res.data });
    });
    // axios
    //   .all([
    //     axios.get(apiUrl + "api/users/getVerifierPatientsPercentage"),
    //     axios.get(apiUrl + "api/users/allverifiers"),
    //   ])
    //   .then(
    //     axios.spread((patientsRes, verifiersRes) => {
    //       const filteredPatients = patientsRes.data.sortedPatients.filter(
    //         (patient) =>
    //           patient.Confirmation === "Yes" || patient.Confirmation === "No"
    //       );

    //       this.setState(
    //         {
    //           patients: filteredPatients,
    //           allverifiers: verifiersRes.data,
    //         },
    //         () => {
    //           // Sorting logic remains unchanged
    //           const sortedPatients = this.state.patients
    //             .slice()
    //             .sort((a, b) => {
    //               // Helper: parse date
    //               function parseDate(dateStr, isIso) {
    //                 if (!dateStr) return new Date(0);
    //                 if (isIso) return new Date(dateStr);
    //                 let formatted = dateStr.replace(" ", "T");
    //                 if (!/Z|[+-]\d{2}:?\d{2}$/.test(formatted)) {
    //                   formatted += "+00:00";
    //                 }
    //                 return new Date(formatted);
    //               }
    //               // Get time left (negative means timer over)
    //               function getTimeLeft(patient) {
    //                 const now = new Date();
    //                 const date = patient.ConfirmupdatedDate
    //                   ? parseDate(patient.ConfirmupdatedDate, true)
    //                   : parseDate(patient.updatedDate, false);
    //                 let timeLimit = 4;
    //                 if (
    //                   patient.deviceInfo &&
    //                   patient.deviceInfo.priority !== undefined
    //                 ) {
    //                   switch (patient.deviceInfo.priority) {
    //                     case 1:
    //                       timeLimit = 1;
    //                       break;
    //                     case 2:
    //                       timeLimit = 2;
    //                       break;
    //                     case 3:
    //                       timeLimit = 3;
    //                       break;
    //                     case 4:
    //                       timeLimit = 4;
    //                       break;
    //                     case 5:
    //                       timeLimit = 5;
    //                       break;
    //                     default:
    //                       timeLimit = 4;
    //                   }
    //                 }
    //                 let exp_device =
    //                   patient.exp_device_use_days === 24
    //                     ? 1
    //                     : patient.exp_device_use_days === 48
    //                     ? 2
    //                     : patient.exp_device_use_days === 72
    //                     ? 3
    //                     : patient.exp_device_use_days;
    //                 const allowedMs = timeLimit * exp_device * 60 * 60 * 1000;
    //                 return date.getTime() + allowedMs - now.getTime();
    //               }
    //               // 1. Sort by report_status: 0, then 2, then 6
    //               const statusOrder = { 0: 1, 2: 2, 6: 3 };
    //               const aStatus = statusOrder[a.report_status] || 99;
    //               const bStatus = statusOrder[b.report_status] || 99;
    //               if (aStatus !== bStatus) {
    //                 return aStatus - bStatus;
    //               }
    //               // 2. For report_status == 0, sort timer over first, then others by time left ascending
    //               if (aStatus === 1) {
    //                 const aTimeLeft = getTimeLeft(a);
    //                 const bTimeLeft = getTimeLeft(b);
    //                 // Timer over (negative time left) comes first
    //                 if (aTimeLeft < 0 !== bTimeLeft < 0) {
    //                   return aTimeLeft < 0 ? -1 : 1;
    //                 }
    //                 // Otherwise, sort by time left ascending (closer to timer over first)
    //                 return aTimeLeft - bTimeLeft;
    //               }
    //               // 3. For report_status == 2, sort timer over first, then others by time left ascending
    //               if (aStatus === 2) {
    //                 const aTimeLeft = getTimeLeft(a);
    //                 const bTimeLeft = getTimeLeft(b);
    //                 if (aTimeLeft < 0 !== bTimeLeft < 0) {
    //                   return aTimeLeft < 0 ? -1 : 1;
    //                 }
    //                 return aTimeLeft - bTimeLeft;
    //               }
    //               // 4. For report_status == 3, sort timer over first, then others by time left ascending
    //               if (aStatus === 3) {
    //                 const aTimeLeft = getTimeLeft(a);
    //                 const bTimeLeft = getTimeLeft(b);
    //                 if (aTimeLeft < 0 !== bTimeLeft < 0) {
    //                   return aTimeLeft < 0 ? -1 : 1;
    //                 }
    //                 return aTimeLeft - bTimeLeft;
    //               }
    //               // 5. Otherwise, fallback to priority
    //               const priorityA =
    //                 a.deviceInfo && a.deviceInfo.priority !== undefined
    //                   ? a.deviceInfo.priority
    //                   : 4;
    //               const priorityB =
    //                 b.deviceInfo && b.deviceInfo.priority !== undefined
    //                   ? b.deviceInfo.priority
    //                   : 4;
    //               return priorityA - priorityB;
    //             });

    //           const data = {
    //             columns: [
    //               { label: "SL NO", field: "slno", sort: "asc", width: 0.5 },
    //               {
    //                 label: "PATIENT ID",
    //                 field: "patientId",
    //                 sort: "asc",
    //                 width: 5,
    //               },
    //               {
    //                 label: "ADDED DATE",
    //                 field: "added_date",
    //                 sort: "asc",
    //                 width: 5,
    //               },
    //               { label: "NAME", field: "name", sort: "asc", width: 5 },
    //               {
    //                 label: "DISTRIBUTOR",
    //                 field: "distributor",
    //                 sort: "disabled",
    //                 width: 5,
    //               }, // Existing column
    //               {
    //                 label: "DOCTOR NAME",
    //                 field: "doctor_name",
    //                 sort: "asc",
    //                 width: 5,
    //               },
    //               {
    //                 label: "Priority",
    //                 field: "priority",
    //                 sort: "disabled",
    //                 width: 5,
    //               }, // Existing column
    //               {
    //                 label: "Pace",
    //                 field: "pacemaker",
    //                 sort: "disabled",
    //                 width: 5,
    //               },
    //               {
    //                 label: "ACTION",
    //                 field: "action",
    //                 sort: "disabled",
    //                 width: 5,
    //               },
    //               ...(this.state.verifiertype === "8"
    //                 ? [
    //                     {
    //                       label: "REPORT",
    //                       field: "report",
    //                       sort: "disabled",
    //                       width: 5,
    //                     },
    //                   ]
    //                 : []),
    //               {
    //                 label: "MONITORING",
    //                 field: "monitoring_duration",
    //                 sort: "disabled",
    //                 width: 1,
    //               }, // Existing column
    //             ],
    //             rows: [],
    //           };

    //           sortedPatients.forEach((patient, i) => {
    //             const Priority =
    //               (patient.deviceInfo && patient.deviceInfo.Priority) || 4; // Set Priority value

    //             // Variable to store the final time value
    //             let finalTime;

    //             // Ensure the date fields are not undefined or null before splitting
    //             if (patient.ConfirmupdatedDate) {
    //               // Split the 'ConfirmupdatedDate' by 'T' to get the date and time parts
    //               let confirmButtonTime = patient.ConfirmupdatedDate.split("T");

    //               // Get the date part before 'T'
    //               let confirmDate = confirmButtonTime[0]; // '2024-11-29'

    //               // Get the time part after 'T'
    //               let confirmTime = confirmButtonTime[1]
    //                 ? confirmButtonTime[1].split("Z")[0] // Remove 'Z' if it exists
    //                 : ""; // If no time part, default to an empty string

    //               // Handle removing milliseconds (if any) from confirmTime
    //               if (confirmTime) {
    //                 let time = confirmTime.split(".")[0]; // Get time without milliseconds
    //                 const confirmbtnTime = confirmDate + " " + time; // Add a space between date and time
    //                 // console.log("Confirm button time:", confirmbtnTime);

    //                 // Assign confirmbtnTime to finalTime if available
    //                 finalTime = confirmbtnTime;
    //               } else {
    //                 // console.log("Confirm Time is empty or invalid");
    //               }
    //             } else {
    //               // console.log("ConfirmupdatedDate is undefined or null");
    //             }

    //             // Check and split the 'updatedDate' if it's available
    //             if (patient.updatedDate) {
    //               // Split the 'updatedDate' by space to separate date and time
    //               let updatedDateTime = patient.updatedDate.split(" ");

    //               // Get the date part before the space
    //               let updatedDate = updatedDateTime[0]; // '2024-11-29'

    //               // Get the time part after the space
    //               let updatedTime = updatedDateTime[1]; // '10:28:34'

    //               // console.log("Updated Date:", updatedDate, updatedTime);

    //               // Combine updatedDate and updatedTime with a space between them
    //               const uploadedTime = updatedDate + " " + updatedTime;

    //               // Assign uploadedTime to finalTime if confirmbtnTime was not set
    //               if (!finalTime) {
    //                 finalTime = uploadedTime;
    //               }
    //             } else {
    //               // console.log("UpdatedDate is undefined or null");
    //             }

    //             // Log the final time
    //             // console.log("Final Time:", finalTime);

    //             // Get the current time
    //             const now = new Date();

    //             // Convert finalTime to Date object
    //             const finalDate = new Date(finalTime);

    //             // Calculate the time difference in milliseconds
    //             const timeDifference = now - finalDate; // in milliseconds

    //             // Convert time difference to hours
    //             const hoursDifference = timeDifference / (1000 * 60 * 60); // milliseconds to hours

    //             // Set the time limit based on priority
    //             let timeLimit;
    //             switch (Priority) {
    //               case 1:
    //                 timeLimit = 1; // 1 hours
    //                 break;
    //               case 2:
    //                 timeLimit = 2; // 3 hours
    //                 break;
    //               case 3:
    //                 timeLimit = 3;
    //               case 4:
    //                 timeLimit = 4; // 4 hours
    //                 break;
    //               case 5:
    //                 timeLimit = 5; // 8 hours
    //                 break;
    //               default:
    //                 timeLimit = 4; // 10 hours (for priority 5, as an example)
    //             }

    //             // Calculate the percentage of time used

    //             let exp_device =
    //               patient.exp_device_use_days === 24
    //                 ? 1
    //                 : patient.exp_device_use_days === 48
    //                 ? 2
    //                 : patient.exp_device_use_days === 72
    //                 ? 3
    //                 : patient.exp_device_use_days;

    //             let timePercentage =
    //               // (hoursDifference / (timeLimit * exp_device)) * 100;
    //               (hoursDifference / (timeLimit * exp_device)) * 100; // Calculate the percentage of time used
    //             // *
    //             // patient.exp_device_use_days
    //             if (timePercentage > 100) {
    //               timePercentage = 100; // Limit to 100% if the time exceeds the limit
    //             }
    //             // Calculate the completion rate (percentage per hour)
    //             // Calculate the completion rate (percentage per hour)
    //             const completionRate = timePercentage / hoursDifference; // percentage per hour

    //             // Predict the total time to complete 100% (in hours)
    //             const totalCompletionTime = 100 / completionRate; // in hours

    //             // Calculate the remaining time to complete (in hours)
    //             const remainingTimeInHours =
    //               totalCompletionTime - hoursDifference;

    //             // Convert the remaining time to minutes
    //             const remainingTimeInMinutes = remainingTimeInHours * 60;
    //             const totalSeconds = remainingTimeInMinutes * 60;
    //             // Convert minutes into hours and minutes
    //             const hours = Math.floor(remainingTimeInMinutes / 60); // Extract whole hours
    //             const minutes = Math.round(remainingTimeInMinutes % 60); // Get the remaining minutes
    //             const seconds = Math.floor(totalSeconds % 60);
    //             // console.log(`hr:${hours} min:${minutes} sec:${seconds}`);
    //             // Log the predicted remaining time
    //             // console.log(
    //             //   `Predicted Remaining Time: ${hours} hours and ${minutes} minutes`
    //             // );

    //             // console.log("name", patient.name);
    //             // console.log("percetage", timePercentage);
    //             // console.log("timediff", timeDifference);
    //             // console.log("time limit", timeLimit);

    //             // Log the result
    //             // console.log(`Time used: ${hoursDifference.toFixed(2)} hours`);
    //             // console.log(`Time limit for Priority ${Priority}: ${timeLimit} hours`);
    //             // console.log(`Percentage of time used: ${timePercentage.toFixed(2)}%`);
    //             const percentage = timePercentage.toFixed(2);
    //             const devicemac =
    //               patient && patient.deviceInfo && patient.deviceInfo.mac_id;
    //             // console.log("patient", devicemac);
    //             const Distributor_name =
    //               patient &&
    //               patient.deviceInfo &&
    //               patient.deviceInfo.customer_details;
    //             const devicepriority =
    //               patient && patient.deviceInfo && patient.deviceInfo.priority;

    //             const totalEcgValues = patient.ecgValues.length;
    //             const verifiedEcgValues = patient.ecgValues.filter(
    //               (ecgValue) => ecgValue.verifyStatus === 1
    //             );
    //             const verifiedPercentage = `${verifiedEcgValues.length} /${totalEcgValues} `;

    //             const createdData = patient.created_at.split("T");

    //             let url = " ";
    //             let anl_btn_txt = "teststart";
    //             let anl_btn_class = "btn-danger";
    //             let gen_btn_txt = "Not Generated";
    //             let gen_btn_class = "btn-danger";
    //             let report_link = "#";
    //             let report_link_target = "";

    //             if (patient.LastDatasetId !== undefined) {
    //               url =
    //                 patient.backup_status === 0 ||
    //                 patient.backup_status === undefined
    //                   ? `/verifier-unanalysed/${patient._id}/${patient.LastDatasetId}`
    //                   : " ";
    //             }

    //             if (patient.report_status >= 1) {
    //               anl_btn_txt = "Analyzing...";
    //               anl_btn_class = "btn-success";
    //             }

    //             if (patient.report_status >= 2) {
    //               anl_btn_txt = "test";
    //               anl_btn_class = "btn-success";
    //               url =
    //                 patient.backup_status === 0 ||
    //                 patient.backup_status === undefined
    //                   ? `/verifier-chart/${patient._id}/${patient.LastDatasetId}`
    //                   : " ";
    //             }

    //             if (patient.report_status >= 4) {
    //               gen_btn_txt = "In Preparation";
    //               gen_btn_class = "btn-yellow";
    //             }
    //             if (patient.report_status >= 5) {
    //               gen_btn_txt = "Not Generated";
    //               gen_btn_class = "btn-danger";
    //               report_link_target = "_blank";
    //               report_link =
    //                 "https://web.mybiocalculus.com/assets/dist/user_records/" +
    //                 patient._id +
    //                 "/Report" +
    //                 patient._id +
    //                 ".pdf";
    //             }

    //             anl_btn_txt =
    //               patient.backup_status === 0 ||
    //               patient.backup_status === undefined
    //                 ? "TEST3"
    //                 : patient.backup_status === 1
    //                 ? "Retrieve"
    //                 : "Retrieving";

    //             const updateddate = patient.ConfirmupdatedDate
    //               ? patient.ConfirmupdatedDate.replace("T", " ").split(
    //                   ".000Z"
    //                 )[0]
    //               : patient.updatedDate;

    //             data.rows.push({
    //               report_status: patient.report_status,
    //               slno: i + 1,
    //               patientId: patient.device_id,
    //               added_date: createdData[0],

    //               name: patient.name, // Default value
    //               distributor: Distributor_name, // Default value // Ensure `distributor` is populated
    //               doctor_name: patient.doctorName, // Default value
    //               priority: devicepriority || "N/A",
    //               pacemaker:
    //                 patient.hyper_lipidemia === true
    //                   ? "Yes"
    //                   : patient.hyper_lipidemia === false
    //                   ? "No"
    //                   : "N/A",
    //               // Ensure `doctor_name` is populated
    //               action: (
    //                 <React.Fragment>
    //                   <div
    //                     style={{
    //                       margin: "auto",
    //                       width: "132%",
    //                       marginLeft: "-14%",
    //                     }}
    //                   >
    //                     <ProgressBtn
    //                       id={patient._id}
    //                       bc_stat={patient.backup_status}
    //                       onSelectModalComplete={this.handleModalComplete}
    //                       r_stat={patient.report_status}
    //                       socket={this.state.socketNew}
    //                     />
    //                     {this.state.verifiertype === "8" && (
    //                       <button
    //                         type="button"
    //                         id={patient._id}
    //                         dataid2={devicemac}
    //                         dataid3={devicepriority}
    //                         style={{
    //                           float: "left",
    //                           marginRight: "10px",
    //                           width: "47px",
    //                           height: "40px", // optional for fixed height
    //                           display: "flex", // flexbox for centering
    //                           alignItems: "center", // vertical center
    //                           justifyContent: "center", // horizontal center
    //                         }}
    //                         onClick={this.getInfo}
    //                         className="btn btn-warning"
    //                         data-toggle="modal"
    //                         data-target="#editInfoModal"
    //                       >
    //                         Edit
    //                       </button>
    //                     )}
    //                     <button
    //                       key={patient.id}
    //                       id={patient._id}
    //                       hourcomplete={`${hours} hours and ${minutes} minutes`}
    //                       type="button"
    //                       style={{
    //                         float: "left",
    //                         marginRight: "10px",
    //                         width: "57px",
    //                         height: "40px", // optional for fixed height
    //                         display: "flex", // flexbox for centering
    //                         alignItems: "center", // vertical center
    //                         justifyContent: "center", // horizontal center
    //                       }}
    //                       className="btn btn-primary"
    //                       data-toggle="modal"
    //                       onClick={this.getverifiedprogress}
    //                       data-target="#progressinfomodal"
    //                     >
    //                       {verifiedPercentage}
    //                     </button>
    //                     {this.state.verifiertype === "8" && (
    //                       <select
    //                         style={{
    //                           color: "black",
    //                           width: "80px",
    //                           height: "36px",
    //                           float: "left",
    //                           backgroundColor: "gray",
    //                           border: "none",
    //                         }}
    //                       >
    //                         {this.state.allverifiers.filter((verifier) =>
    //                           verifier.patients.includes(patient._id)
    //                         ).length === 0 && (
    //                           <option
    //                             style={{ color: "gray" }}
    //                             disabled
    //                             selected
    //                           >
    //                             Not Assigned
    //                           </option>
    //                         )}
    //                         {this.state.allverifiers
    //                           .filter((verifier) =>
    //                             verifier.patients.includes(patient._id)
    //                           )
    //                           .map((verifier) => (
    //                             <option
    //                               style={{ color: "black" }}
    //                               key={verifier._id}
    //                               value={verifier._id}
    //                             >
    //                               {verifier.name}
    //                             </option>
    //                           ))}
    //                       </select>
    //                     )}

    //                     <button
    //                       type="button"
    //                       id={patient._id}
    //                       style={{
    //                         float: "left",
    //                         marginLeft: "10px",
    //                         width: "130px",
    //                         marginRight: "10px",
    //                       }}
    //                       onClick={this.getInfo}
    //                       className="btn btn-warning"
    //                       data-toggle="modal"
    //                       data-target="#commentinfomodal"
    //                     >
    //                       comments
    //                     </button>

    //                     {this.state.verifiertype === "8" &&
    //                     !patient.ConfirmupdatedDate ? (
    //                       <button
    //                         type="button"
    //                         id={patient._id}
    //                         style={{
    //                           float: "left",
    //                           marginLeft: "0px",
    //                           width: "80px",
    //                           marginRight: "10px",
    //                           backgroundColor: "transparent",
    //                           border: "none",
    //                           fontSize: "30px",
    //                           padding: "10px 20px",
    //                           borderRadius: "5px",
    //                           cursor: "pointer",
    //                         }}
    //                         onClick={this.getConfirmTime}
    //                         className="btn"
    //                       >
    //                         ✅
    //                       </button>
    //                     ) : null}
    //                   </div>
    //                 </React.Fragment>
    //               ),

    //               report: (
    //                 <div
    //                   style={
    //                     this.state.verifiertype !== "8"
    //                       ? { display: "none", marginLeft: "11%", width: "93%" }
    //                       : { marginLeft: "11%", width: "93%" }
    //                   }
    //                 >
    //                   {/* Progress bar to show the percentage of completion */}
    //                   <div style={{ margin: "10px 0" }}>
    //                     <label htmlFor="progressBar">
    //                       TAT:{" "}
    //                       <Countdown
    //                         date={
    //                           Date.now() + remainingTimeInMinutes * 60 * 1000
    //                         }
    //                         renderer={({
    //                           hours,
    //                           minutes,
    //                           seconds,
    //                           completed,
    //                         }) => {
    //                           if (completed) {
    //                             return (
    //                               <span
    //                                 style={{
    //                                   color: "red",
    //                                   display: "flex",
    //                                   alignItems: "center",
    //                                   gap: "6px",
    //                                 }}
    //                               >
    //                                 ⏰ Time Over
    //                               </span>
    //                             );
    //                           } else {
    //                             return (
    //                               <span>
    //                                 {hours}h : {minutes}m : {seconds}s
    //                               </span>
    //                             );
    //                           }
    //                         }}
    //                       />
    //                     </label>
    //                     <div
    //                       style={{
    //                         height: "20px",
    //                         width: "106%",
    //                         backgroundColor: "#e0e0df",
    //                         borderRadius: "5px",
    //                         overflow: "hidden",
    //                         marginTop: "5px",
    //                         position: "relative",
    //                       }}
    //                     >
    //                       {/* Progress bar filled section */}
    //                       <div
    //                         style={{
    //                           height: "100%",
    //                           width: `${timePercentage}%`, // Adjust based on percentage value
    //                           backgroundColor:
    //                             timePercentage >= 80
    //                               ? "#8f0303"
    //                               : timePercentage >= 50
    //                               ? "orange"
    //                               : "#2ecd99", // Red for 80-100%, Orange for 50-79%, Green otherwise
    //                           transition: "width 0.5s ease",
    //                           position: "absolute",
    //                           top: 0,
    //                           left: 0,
    //                         }}
    //                       ></div>

    //                       {/* Centered percentage text */}
    //                       <div
    //                         style={{
    //                           position: "absolute",
    //                           top: 0,
    //                           left: 0,
    //                           height: "100%",
    //                           width: "100%",
    //                           display: "flex",
    //                           alignItems: "center",
    //                           justifyContent: "center",
    //                           fontWeight: "bold",
    //                           color: "#120d0d", // Sets the text color to black
    //                         }}
    //                       >
    //                         {timePercentage.toFixed(2)}%
    //                       </div>
    //                     </div>
    //                   </div>

    //                   <React.Fragment>
    //                     <a
    //                       id={patient._id}
    //                       style={
    //                         gen_btn_class === "btn-yellow"
    //                           ? { backgroundColor: "#2ecd99" }
    //                           : {}
    //                       }
    //                       onClick={() =>
    //                         this.generateReport(
    //                           patient.report_status,
    //                           patient._id
    //                         )
    //                       }
    //                     >
    //                       <button
    //                         type="button"
    //                         className={`btn ${gen_btn_class}`}
    //                         style={
    //                           gen_btn_class === "btn-yellow"
    //                             ? { backgroundColor: "#2ecd99" }
    //                             : {}
    //                         }
    //                       >
    //                         {gen_btn_txt}
    //                       </button>
    //                     </a>
    //                     <input
    //                       type="hidden"
    //                       className="patientLink"
    //                       value={url}
    //                     />
    //                   </React.Fragment>
    //                 </div>
    //               ),

    //               monitoring_duration: (
    //                 <div
    //                   data-toggle="modal"
    //                   data-target="#showblockreport"
    //                   style={{ width: "115px", cursor: "pointer" }}
    //                   onClick={async (e) => {
    //                     const data = await axios.get(
    //                       `${apiUrl}api/common/getblockpatient?userid=${patient._id}`
    //                     );
    //                     console.log("block data", data.data.data.BlockReport);
    //                     this.setState({
    //                       blockReportOption: data.data.data.BlockReport || "No",
    //                     });
    //                     this.setState({ userid: patient._id });
    //                   }}
    //                 >
    //                   {patient.exp_device_use_days}DAYS ({updateddate})
    //                 </div>
    //               ),
    //               TimePercentage: (
    //                 <div
    //                   style={{
    //                     color: "transparent",
    //                     display: "flex",
    //                     position: "absolute",
    //                   }}
    //                 >
    //                   {percentage}
    //                 </div>
    //               ),
    //               hourstocompleted: (
    //                 <div
    //                   style={{
    //                     color: "transparent",
    //                     display: "flex",
    //                     position: "absolute",
    //                   }}
    //                 >
    //                   {`${hours} hours and ${minutes} minutes`}
    //                 </div>
    //               ),
    //             });
    //           });

    //           this.setState({ data: data });
    //           this.setState({ columns: data.columns });
    //           this.setState(
    //             {
    //               rows: data.rows.sort((a, b) => {
    //                 // Extract date from monitoring_duration field: "1DAYS (2025-08-15 21:50:34)"
    //                 const extractDate = (row) => {
    //                   const match = String(
    //                     row.monitoring_duration.props.children
    //                   ).match(/\(([^)]+)\)/);
    //                   // Support both ISO and non-ISO formats
    //                   if (match) {
    //                     // Remove any milliseconds and trailing Z
    //                     let cleaned = match[1].replace(/\.[0-9]+Z?$/, "");
    //                     let date = new Date(cleaned);
    //                     // If still invalid, fallback to original
    //                     if (isNaN(date.getTime())) {
    //                       date = new Date(match[1]);
    //                     }
    //                     return date;
    //                   }
    //                   return new Date(0);
    //                 };
    //                 const dateA = extractDate(a);
    //                 const dateB = extractDate(b);
    //                 // Sort descending: most recent date first
    //                 return dateB - dateA;
    //               }),
    //             },
    //             () => {
    //               // this.applyRowStyles(); // Apply styles to rows

    //               // Bind click events for table rows after setting state
    //               // const table = document.getElementById("table");
    //               // if (table) {
    //               //   table.addEventListener("click", this.handleRowClick);
    //               // }

    //               // Check for TAT notifications after data is loaded
    //               // this.checkTatNotifications();
    //             }
    //           );

    //           // this.setState({ data }, () => {
    //           //   this.applyRowStyles();

    //           //   // Bind click events for table rows
    //           //   const table = document.getElementById("table");
    //           //   table.addEventListener("click", (event) => {
    //           //     const target = event.target;
    //           //     if (
    //           //       target.closest(
    //           //         "td:nth-child(2), td:nth-child(3), td:nth-child(4)"
    //           //       )
    //           //     ) {
    //           //       const url = target
    //           //         .closest("tr")
    //           //         .querySelector(".patientLink").value;
    //           //       if (url !== " ") {
    //           //         window.location.href = url;
    //           //         // console.log("url:", url);
    //           //       }
    //           //     }
    //           //   });
    //           // });
    //         }
    //       );
    //     })
    //   )
    //   .catch((err) => {
    //     console.error("Error fetching data:", err);
    //   });
  };
  handleDoctorChange = (selectedOption) => {
    this.setState({ selectedDoctor: selectedOption });
    // console.log("Selected doctor:", selectedOption);
    // Perform any action needed with the selected doctor
  };
  handleSearch = (event) => {
    const searchValue = event.target.value.toLowerCase();
    this.setState({ search: searchValue });
  };
  handleSort = (field) => {
    const { sortField, sortDirection, data } = this.state;
    const direction =
      sortField === field && sortDirection === "asc" ? "desc" : "asc";

    const sortedRows = [...data.rows].sort((a, b) => {
      if (a[field] < b[field]) return direction === "asc" ? -1 : 1;
      if (a[field] > b[field]) return direction === "asc" ? 1 : -1;
      return 0;
    });

    this.setState({
      sortField: field,
      sortDirection: direction,
      data: { ...data, rows: sortedRows },
    });
  };
  handlePageSizeChange = (event) => {
    const pageSize = parseInt(event.target.value, 10);
    this.setState({ pageSize });
  };

  invertEcg(e) {
    const userid = e.currentTarget.id;
    console.log(e.currentTarget.id);
    axios.get(
      `https://web.mybiocalculus.com/html/welcome/analyzeAll/?userid=${userid}&&type=/home/ubuntu/web_analysis/single_invert.py`
    );
    axios.get(
      `https://web.mybiocalculus.com/html/welcome/analyzeAll/?userid=${userid}&&type=/home/ubuntu/web_analysis/single_invert.py`
    );
  }
  fetchPatients = async (pageNumber) => {
    try {
      const res = await axios.get(
        apiUrl + "api/users/getSupportPatientsNewmodalWeb?page=" + pageNumber
      );
      const patients = res.data;

      const data = {
        columns: [
          { label: "SL NO", field: "slno", sort: "asc", width: 50 },
          {
            label: "PATIENT NAME",
            field: "patientName",
            sort: "asc",
            width: 200,
          },
          { label: "Trigger", field: "Trigger", sort: "asc", width: 250 },
          { label: "Doctor", field: "doctorName", sort: "asc", width: 200 },
          { label: "Phone", field: "phone", sort: "asc", width: 200 },
          { label: "Serial No", field: "serial_no", sort: "asc", width: 250 },
          { label: "Gender", field: "gender", sort: "asc", width: 50 },
          { label: "Hospital", field: "hospital", sort: "asc", width: 200 },
          { label: "Duration", field: "duration", sort: "asc", width: 100 },
          { label: "Mac ID", field: "Mac_id", sort: "asc", width: 400 },
          {
            label: "Battery Percentage",
            field: "BatteryPercentage",
            sort: "disabled",
            width: 100,
          },
          {
            label: "Backup Status",
            field: "backup",
            sort: "disabled",
            width: 200,
          },
          { label: "Symptoms", field: "symptoms", sort: "asc", width: 200 },
          { label: "IP/OP", field: "ip_op", sort: "asc", width: 200 },
          { label: "Patient ID", field: "device_id", sort: "asc", width: 200 },
          {
            label: "Recording Status",
            field: "RecordingStatus",
            sort: "asc",
            width: 200,
          },
          {
            label: "Customer",
            field: "customer_details",
            sort: "asc",
            width: 200,
          },
          { label: "Created On", field: "created", sort: "asc", width: 200 },
          { label: "Invert", field: "Invert", sort: "disabled", width: 200 },
          { label: "Status", field: "status", sort: "disabled", width: 200 },
          { label: "Action", field: "action", sort: "disabled", width: 200 },
          { label: "Diary", field: "diary", sort: "disabled", width: 200 },
        ],
        rows: [],
      };

      patients.forEach((patient, i) => {
        // console.log("patient!!!!!!!!!", patient._id);
        var anl_btn_txt = "Analyze";
        var anl_btn_class = "btn-danger";
        var gen_btn_txt = "Not Analyzed";
        var gen_btn_class = "btn-danger";
        var report_link = "#";
        var report_link_target = "";
        var report_status = patient.report_status;
        window.backup_status = patient.backup_status;
        const recordingStatus = patient.RecordingStatus;

        // Function to render status message based on RecordingStatus
        const renderStatusMessage = () => {
          switch (recordingStatus) {
            case 0:
              return " recording Not started";
            case 1:
              return "Recording Mode";
            case 3:
              return "Data uploaded";
            default:
              return "Unknown status";
          }
        };
        const createdData = patient.created_at.split("T");
        const customerDetailsText = 
          patient.customerName && patient.customerName !== "NA"
            ? patient.customerName
            : patient.customer_details && patient.customer_details.length > 0
              ? patient.customer_details
                  .map((detail) => detail.customer_details)
                  .join(" ")
              : "No customer details available";
        // if (patient.device_id == 231396) {
        //   console.log("Customer details:", patient.customerName, patient.device_id, patient);
        // }
        data.rows.push({
          slno: i + 1,
          patientName: patient.name,
          Trigger: (
            <React.Fragment>
              <a href="#" style={{ display: "flex", flexDirection: "column" }}>
                <button
                  type="button"
                  id={patient._id}
                  onClick={this.Trigger_old}
                  className="btn btn-warning mr-20"
                  data-toggle="modal"
                >
                  Trigger Old
                </button>
                <button
                  type="button"
                  id={patient._id}
                  onClick={this.Trigger}
                  className="btn btn-warning mr-20"
                  data-toggle="modal"
                >
                  Trigger New
                </button>
              </a>
            </React.Fragment>
          ),
          doctorName: patient.doctor_name,
          phone: patient.phone,
          serial_no: <Serialno patient={patient} />,
          serial_o: patient.serial_no,


          gender: patient.gender,
          hospital: patient.hospital,
          activeMorning: patient.ActiveMorning || "_",
          activeEvening: patient.ActiveEvening || "_",
          issuereported: patient.issueReported || "_",
          duration: patient.exp_device_use_days,
          Mac_id: patient.Mac_id,
          BatteryPercentage: <YourComponent patient={patient} />,
          backup: <BackupButton patient={patient} />,
          symptoms: patient.indication,
          ip_op: patient.ip_op,
          device_id: patient.device_id,
          RecordingStatus: renderStatusMessage(),
          customer_details: customerDetailsText,
          created: createdData[0],
          Invert: (
            <React.Fragment>
              <a href="#">
                <button
                  type="button"
                  id={patient._id}
                  onClick={this.invertEcg}
                  className="btn btn-warning mr-20"
                  data-toggle="modal"
                >
                  Invert
                </button>
              </a>
            </React.Fragment>
          ),
          Status: (
            <React.Fragment>
              <a href="#">
                <button
                  type="button"
                  id={patient._id}
                  className="btn btn-primary  mr-20"
                >
                  {gen_btn_txt}
                </button>
              </a>
            </React.Fragment>
          ),
          action: (
            <React.Fragment>
              <a href="#">
                <button
                  type="button"
                  id={patient._id}
                  onClick={() => this.getInfo(patient._id)}
                  className="btn btn-warning mr-20"
                  data-toggle="modal"
                  data-target="#editInfoModal"
                >
                  Edit
                </button>
              </a>
            </React.Fragment>
          ),
          diary: (
            <React.Fragment>
              <a href="#">
                <button
                  type="button"
                  id={patient._id}
                  className="btn btn-warning mr-20"
                  data-toggle="modal"
                  data-target="#editDiaryModal"
                >
                  Diary
                </button>
              </a>
            </React.Fragment>
          ),
        });
      });

      this.setState({
        patients: patients,
        data: data,
        totalPages: Math.ceil(patients.length / this.state.pageSize),
      });
    } catch (err) {
      console.error(err);
    }
  };

  onSubmit = (e) => {
    e.preventDefault();
    const settings = {
      userid: this.state.userid,
      nor_minhr: this.state.nor_minhr,
      nor_maxhr: this.state.nor_maxhr,
      qtcformula: this.state.qtcformula,
      qtcvalue_min: this.state.qtcvalue_min,
      qtcvaluemax: this.state.qtcvaluemax,
      qrswidth_min: this.state.qrswidth_min,
      qrswidth_max: this.state.qrswidth_max,
      qrsamp_min: this.state.qrsamp_min,
      qrsamp_max: this.state.qrsamp_max,
      stelevation: this.state.stelevation,
      pwidth_min: this.state.pwidth_min,
      pwidth_max: this.state.pwidth_max,
      pamp_min: this.state.pamp_min,
      pamp_max: this.state.pamp_max,
      stdepression: this.state.stdepression,
      twidth_min: this.state.twidth_min,
      twidth_max: this.state.twidth_max,
      tamp_min: this.state.tamp_min,
      tamp_max: this.state.tamp_max,
      printerval_min: this.state.printerval_min,
      printerval_max: this.state.printerval_max,
      tachyhr_lower: this.state.tachyhr_lower,
      tachyhr_upper: this.state.tachyhr_upper,
      bradyhr_lower: this.state.bradyhr_lower,
      bradyhr_upper: this.state.bradyhr_upper,
      pauselength: this.state.pauselength,
      graph_gen: this.state.graph_gen,
    };

    // console.log(settings);
    axios
      .post(apiUrl + "api/patients/updateSettings", settings)
      .then((res) => {
        $("#closePopup").click();
      })
      .catch((err) => {
        console.log(err);
      });
  };
  onSubmitDiary = (e) => {
    e.preventDefault();
    var uid = this.props.userid;
    var did = this.props.databaseid;
    var finTime = document.getElementById("addTime").value;

    const info = {
      id: this.props.userid,
      datetime: finTime,
      diary_notes: this.state.addNote,
      act_duration: this.state.act_duration,
      activity: this.state.activity,
    };
    // console.log("info", info);
    axios
      .post(apiUrl + "api/patients/addDiary", info)
      .then((res) => {
        // console.log(res.data);
        $(".closePopup").click();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  onSubmitInfo = (e) => {
    e.preventDefault();

    //   this.state.selectedVerifiers.forEach(verifier => {
    //     console.log("Verifier ID:", verifier.value);
    // });

    const info = {
      name: this.state.patient_name,
      patientid: this.state.userid,
      userid: this.state.userid,
      dob: this.state.dob,
      weight: this.state.weight,
      height: this.state.height,
      hospital: this.state.hospital,
      phone: this.state.phone,
      email: this.state.email_id,
      doctorid: this.state.selectedDoctor.value,
      ipop: this.state.ipop,
      fileType: this.state.filetype || "easy",
      verifierid: this.state.selectedVerifiers.map(
        (verifier) => verifier.value
      ),
      priority: this.state.priority,

      reportstatus: this.state.reportstatus,
      // smoking: this.state.smoking,
      // diabetes: this.state.diabetes,
      af: this.state.af,
      // hyper_tension: this.state.hyper_tension,
      // hyper_lipidemia: this.state.hyper_lipidemia,
      hyper_lipidemia: this.state.pacemaker,
      indication: this.state.indication,
      cardiac_surgery: this.state.cardiac_surgery,
      thyroid: this.state.thyroid_function,
      exp_device_use_days: this.state.duration,
      issueReported: this.state.issueReport,
      supportLevel: this.state.supportLevel,
      supportPerson: this.state.supportPerson,
      supportcomment: this.state.supportedMatter,
      prioritizeData: this.state.prioritizeData, // <-- Add this line
      clinicalCondition: this.state.clinicalCondition, // <-- Add this line
    };
    // console.log("info:", this.state.clinicalCondition);

    const deviceinfoupdate = {
      mac_id: this.state.macid,
      priority: this.state.priority,
    };

    axios
      .post(apiUrl + "api/patients/updateInfo_new_info_test", info)
      .then((res) => {
        // Handle the response of the first request
        // console.log("Patient info updated:", res.data);
        if (this.state.macid != null) {
          // If macid is either undefined or null
          return axios.put(
            `${apiUrl}api/patients/updateDevicePriority`,
            deviceinfoupdate
          );
        }
      })

      .then((res) => {
        // Handle the response of the second request
        // console.log("Device priority updated:", res.data);
        $(".closePopup").click();
        this.fetchData(); // Fetch updated data
      })
      .catch((err) => {
        // Handle any errors from either request
        console.error("Error occurred:", err);
      });
  };

  onChange = (e) => {
    var err = this.state.errors;
    delete err[e.target.name];
    this.setState({ [e.target.name]: e.target.value });
  };

  preventDefault(e) {
    e.preventDefault();
  }

  openTriggerModal = (type, e) => {
    const userid = e.currentTarget.id;
    this.setState({
      triggerModalOpen: true,
      triggerType: type,
      triggerUserId: userid,
      triggerWeb: "",
      triggerPatientId: "",
      triggerOutput: null,
      triggerErrors: {},
    });
  };

  closeTriggerModal = () => {
    this.setState({ triggerModalOpen: false });
  };

  handleTriggerInputChange = (e) => {
    const { name, value } = e.target;
    this.setState((prevState) => ({
      [name]: value,
      triggerErrors: {
        ...prevState.triggerErrors,
        [name]: "",
      },
    }));
  };

  validateTriggerForm = () => {
    const { triggerWeb } = this.state;
    const triggerErrors = {};

    if (!triggerWeb || !triggerWeb.trim()) {
      triggerErrors.triggerWeb = "Web is required";
    }

    this.setState({ triggerErrors });
    return Object.keys(triggerErrors).length === 0;
  };

  submitTriggerRequest = (e) => {
    e.preventDefault();
    if (!this.validateTriggerForm()) {
      return;
    }

    const {
      triggerType,
      triggerUserId,
      triggerWeb,
      triggerPatientId,
    } = this.state;

    const payload = {
      userid: triggerUserId,
      web: triggerWeb.trim(),
    };

    if (triggerPatientId && triggerPatientId.trim()) {
      payload.patientid = triggerPatientId.trim();
    }

    const endpoint =
      triggerType === "old"
        ? `${apiUrl4}api/users/Trigger_button`
        : `${apiUrl}api/graph/triggerpatient`;

    axios
      .post(endpoint, payload)
      .then((res) => {
        this.setState({
          triggerOutput: res.data.output || res.data,
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          triggerOutput: "Error fetching data",
        });
      });
  };

  Trigger(e) {
    this.openTriggerModal("new", e);
  }
  Trigger_old(e) {
    this.openTriggerModal("old", e);
  }
  nextPage = () => {
    const { currentPage } = this.state;
    const nextPage = currentPage + 1;
    this.setState({ currentPage: nextPage });
    this.fetchPatients(nextPage);
  };

  prevPage = () => {
    const { currentPage } = this.state;
    const prevPage = currentPage - 1;
    if (prevPage > 0) {
      this.setState({ currentPage: prevPage });
      this.fetchPatients(prevPage);
    }
  };
  setInfo(e) {
    var diary_id = e.currentTarget.id;
    this.state.diary_note_id = diary_id;
    /*var arr=this.search(this.state.diary_notes,diary_id);
     this.setState({time:arr[0].datetime,note:arr[0].diary_notes});
     console.log("diary_id",this.state.diary_note_id);*/
  }
  getInfo(userid) {
    this.setState({
      loadingEditModal: true, // Show loading spinner/modal when edit starts
      smoking: "",
      diabetes: "",
      af: "",
      hyper_tension: "",
      hyper_lipidemia: "",
      indication: "",
      cardiac_surgery: "",
      thyroid_function: "",
      loadingEditModal: true, // Set loading to true when starting
      supportPerson: "",
      supportLevel: "",
      supportedMatter: "",
    });
    this.setState({ isModalCompleteOpen: false });
    // const dataid2 = e.target.getAttribute("dataid2");
    // const dataid3 = e.target.getAttribute("dataid3");
    this.setState({ userid: userid });
    axios
      .get(`${apiUrl}api/patients/getPatinetAdditionalInfo?userid=${userid}`)
      .then((res) => {
        const data = res.data[0];
        if (
          data.gender === "MALE" ||
          data.gender === "male" ||
          data.gender === "Male" ||
          data.gender === "M" ||
          data.gender === "m"
        ) {
          this.setState({ gender: "M" });
        }

        if (
          data.gender === "FEMALE" ||
          data.gender === "female" ||
          data.gender === "Female" ||
          data.gender === "F" ||
          data.gender === "f"
        ) {
          this.setState({ gender: "F" });
        }
        if (data.gender === "Select Gender") {
          this.setState({ gender: "M" });
        }

        if (Array.isArray(this.state.patients)) {
          this.state.patients.forEach((patient) => {
            if (patient._id === userid) {
              this.setState({ reportstatus: patient.report_status });
              // console.log("report status", patient.report_status);
            }
          });
        }
        data.customer_details.forEach((customer) => {
          if (customer.customer_details) {
            // console.log('Nested Customer Details:', customer);
            this.setState({ customer_details: customer.customer_details });
          }
        });
        // console.log(this.state.patients);
        console.log("additional data!!!!!!!!!!!!!!!", data);
        // Update state with patient info
        this.setState({
          af: data.af ? "yes" : "no",
          duration: data.exp_device_use_days,
          cardiac_surgery: data.cardiac_surgery ? "yes" : "no",
          thyroid_function: data.thyroid,
          diabetes: data.diabetes,
          indication: data.indication,
          height: data.height,
          weight: data.weight,
          hospital: data.hospital,
          phone: data.phone,
          patient_name: data.name,
          email_id: data.email,
          selectedDoctor: { value: data.doctor_id, label: data.doctor_name },
          // macid: dataid2,
          // priority: dataid3,
          dob: data.dob,
          duration: data.exp_device_use_days,
          filetype: data.fileType,
          pacemaker: data.hyper_lipidemia,
          issueReport: data.issueReported,
          Confirmation: data.Confirmation,
          supportedMatter: data.supportcomment,
          supportPerson: data.supportPerson,
          supportLevel: data.supportLevel,
          prioritizeData: data.priorityStatus, // <-- Add this line for the new field
          clinicalCondition: data.clinicalCondition, // <-- Add this line for the new field
        });
        console.log("data!!!!!!!!!!!!!!!!!!", data);

        // Handle DOB formatting
        let formattedDob = data.dob;
        if (formattedDob) {
          // Convert ISO string or YYYY-MM-DD to MM/DD/YYYY for display
          const dateObj = new Date(formattedDob);
          if (!isNaN(dateObj.getTime())) {
            const mm = String(dateObj.getMonth() + 1).padStart(2, "0");
            const dd = String(dateObj.getDate()).padStart(2, "0");
            const yyyy = dateObj.getFullYear();
            formattedDob = `${mm}/${dd}/${yyyy}`;
          }
        }
        this.setState({ dob: formattedDob });
        console.log("Formatted DOB:", this.state.dob);

        // Second API call for verifiers
        return axios.get(`${apiUrl}api/users/allverifiers`);
      })
      .then((res) => {
        const verifiers = res.data;
        const formattedVerifiers = verifiers.map((verifier) => ({
          value: verifier._id,
          label: verifier.name,
          patients: verifier.patients, // Assuming patients is an array of user IDs
        }));

        const filteredVerifiers = formattedVerifiers.filter((verifier) =>
          verifier.patients.includes(userid)
        );

        // console.log('Filtered verifiers with matching user:', this.state.priority);

        this.setState({ selectedVerifiers: filteredVerifiers });

        this.setState({ verifiers: formattedVerifiers });
        // console.log('formatted verifiers:',verifiers)
        // Third API call for patient search (ipop)
        this.state.patients.forEach((patient) => {
          if (patient._id === userid) {
            this.setState({ comments: patient.comments });
            // this.setState({ priority: patient.priority });
            this.setState({ ipop: patient.ip_op });
          }
        });

        // console.log("ipop", this.state.patients);

        // Fourth API call for verified percentage
        return axios.get(`${apiUrl}api/users/getVerifiedPercentage/${userid}`);
      })
      .then((res) => {
        const ecgValues = res.data.ecgValues; // Assuming `ecgValues` is an array
        const totalLength = ecgValues.length;
        let verifyCount = 0; // Initialize verify count

        ecgValues.forEach((value, index) => {
          if (value.verifyStatus === 1) {
            // console.log(`Link for ECG value at index ${index}:`, value.link); // Assuming there's a 'link' property
            verifyCount++; // Increment the verify count
          }
        });

        // console.log('Total verified ECG values:', verifyCount);
        // console.log('Total count:', totalLength);

        if (totalLength > 0) {
          // console.log('ECG data is available.');

          // Calculate and log the percentage of verified ECG values
          const percentageVerified = (verifyCount / totalLength) * 100;
          // console.log('Percentage of verified ECG values:', percentageVerified.toFixed(2) + '%');
          this.setState({ percentageVerified: percentageVerified.toFixed(2) });
          // console.log('verified percentage:',this.state.percentageVerified)
        } else {
          // console.log('No ECG data found.');
        }
        this.setState({ loadingEditModal: false }); // Data loaded, hide spinner
        axios.get(`${apiUrl}api/common/getSupportPerson`).then((res) => {
          if (res.data && Array.isArray(res.data)) {
            this.setState({ supportPersons: res.data });
            // console.log("support persons:!!!!!!!!!!!!!!!!!!!!!!", this.state.supportPersons);
          }
        });
      })

      .catch((error) => {
        console.error("Error fetching ECG data:", error);
        this.setState({ loadingEditModal: false }); // Hide spinner on error
      });
  }
  selectItem(e) {
    var userid = e.currentTarget.id;
    this.setState({ userid: userid });
    this.setState({
      nor_minhr: "",
      nor_maxhr: "",
      qtcformula: "",
      qtcvalue_min: "",
      qtcvaluemax: "",
      qrswidth_min: "",
      qrswidth_max: "",
      qrsamp_min: "",
      qrsamp_max: "",
      stelevation: "",
      pwidth_min: "",
      pwidth_max: "",
      pamp_min: "",
      pamp_max: "",
      stdepression: "",
      twidth_min: "",
      twidth_max: "",
      tamp_min: "",
      tamp_max: "",
      printerval_min: "",
      printerval_max: "",
      tachyhr_lower: "",
      tachyhr_upper: "",
      bradyhr_lower: "",
      bradyhr_upper: "",
      pauselength: "",
      graph_gen: "",
    });
    axios
      .get(apiUrl + "api/patients/settings?userid=" + userid)
      .then((res) => {
        var data = res.data;
        this.setState(data);
      })
      .catch((err) => {
        console.log(err);
      });
  }
  exportToCSV = () => {
    const { data, sortField, sortDirection } = this.state;

    // Define columns to exclude (you can modify this list based on your needs)
    const excludedColumns = [
      "Trigger",
      "serial_no",
      "backup",
      "Status",
      "action",
      "diary",
      "BatteryPercentage",
    ];

    // Sort the rows if necessary
    const sortedRows = [...data.rows].sort((a, b) => {
      if (sortField && sortDirection) {
        const aValue = a[sortField];
        const bValue = b[sortField];
        if (sortDirection === "asc") {
          return aValue > bValue ? 1 : -1;
        } else {
          return aValue < bValue ? 1 : -1;
        }
      }
      return 0;
    });

    // Filter the rows if needed (e.g., excluding rows with certain conditions)
    const filteredRows = sortedRows.filter((row) => {
      // Example: exclude rows with 'Status' as 'Inactive'
      return row.Status !== "Inactive"; // Modify this based on your needs
    });

    // Prepare headers by excluding specified columns
    const headers = Object.keys(filteredRows[0]).filter(
      (header) => !excludedColumns.includes(header)
    );

    // Convert rows to CSV format, excluding unwanted columns
    const csvRows = [];
    csvRows.push(headers.join(",")); // Add the header row

    filteredRows.forEach((row) => {
      const values = headers.map((header) => {
        const value = row[header] === null ? "" : row[header]; // Handle null values
        return `"${value}"`; // Wrap each value in quotes to handle commas
      });
      csvRows.push(values.join(","));
    });

    // Create CSV string
    const csvString = csvRows.join("\n");

    // Create a temporary link element to trigger the download
    const link = document.createElement("a");
    link.href = "data:text/csv;charset=utf-8," + encodeURIComponent(csvString);
    link.target = "_blank";
    link.download = "filtered_sorted_data.csv";

    // Trigger the download
    link.click();
  };

  render() {
    if (localStorage.jwtToken == undefined) {
      window.location.href = "/";
    }
    // const { errors, doctors, selectedDoctor,data, search, pageSize, sortField, sortDirection } = this.state;
    // Inside render() method
    const {
      errors,
      doctors,
      selectedDoctor,
      data,
      search,
      pageSize,
      sortField,
      sortDirection,
      dob,
      triggerModalOpen,
      triggerType,
      triggerWeb,
      triggerPatientId,
      triggerOutput,
      triggerErrors,
    } = this.state;

    // Ensure `data` and `data.rows` are defined and check each value before calling `toString()`
    const filteredRows =
      data && data.rows && Array.isArray(data.rows)
        ? data.rows.filter(
            (row) =>
              Object.values(row).some(
                (value) =>
                  // Safely check if value is not undefined or null before calling `toString()`
                  value &&
                  value.toString().toLowerCase().includes(search.toLowerCase())
              ) ||
              // Check if customer_details contains the search value
              (row.customer_details &&
                row.customer_details
                  .toString()
                  .toLowerCase()
                  .includes(search.toLowerCase()))
          )
        : []; // Fallback to empty array if data.rows is undefined

    // Slice rows for pagination
    const displayedRows = filteredRows.slice(
      (this.state.currentPage - 1) * this.state.pageSize,
      this.state.currentPage * this.state.pageSize
    );

    // console.log("selecteddoctors:", selectedDoctor);
    const options = doctors.map((doctor) => ({
      value: doctor._id,
      label: doctor.name,
    }));

    // let doctorsList =
    //   this.state.doctors.length > 0 &&
    //   this.state.doctors.map((item, i) => {
    //     return (
    //       <option
    //         key={i}
    //         value={item._id}
    //         selected={this.state.doctor_name == item.name}
    //       >
    //         {item.name}
    //       </option>
    //     );
    //   }, this);

    return (
      <div className="wrapper theme-1-active box-layout pimary-color-green">
        <TopNav profileLink={this.state.profileLink} />
        <SideBar menus={this.state.menus} />
        <div className="right-sidebar-backdrop"></div>
        <div className="page-wrapper">
          <div className="container-fluid">
            <div id="editDiaryModal" className="modal fade" role="dialog">
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                    >
                      &times;
                    </button>
                    <h4 className="modal-title text-center">Add Diary Notes</h4>
                    <form method="post" onSubmit={this.onSubmitDiary}>
                      <div className="modal-body">
                        <div className="row row-sm-offset">
                          <br />
                          <div className="col-md-6 multi-horizontal">
                            <div className="form-group">
                              <label className="form-control-label mbr-fonts-style display-7">
                                TIME
                              </label>
                              <div
                                className="input-group date"
                                id="datetimepicker2"
                              >
                                <input
                                  id="addTime"
                                  type="text"
                                  className={classnames("form-control", {
                                    errors: errors.time,
                                  })}
                                  onBlur={this.onChange}
                                  value={this.state.time}
                                  name="time"
                                />
                                <span className="input-group-addon">
                                  <span className="fa fa-calendar"></span>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row row-sm-offset">
                          <br />
                          <div className="col-md-6 multi-horizontal">
                            <div className="form-group">
                              <label className="form-control-label mbr-fonts-style display-7">
                                Activity
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                name="activity"
                                onChange={this.onChange}
                                value={this.state.activity}
                              />
                            </div>
                          </div>
                          <div className="col-md-6 multi-horizontal">
                            <div className="form-group">
                              <label className="form-control-label mbr-fonts-style display-7">
                                Duration
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                name="act_duration"
                                onChange={this.onChange}
                                value={this.state.act_duration}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row row-sm-offset">
                          <br />

                          <div className="col-md-12 multi-horizontal">
                            <div className="form-group">
                              <label className="form-control-label mbr-fonts-style display-7">
                                Note
                              </label>
                              <textarea
                                type="textarea"
                                className="form-control"
                                name="addNote"
                                onChange={this.onChange}
                                value={this.state.addNote}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="modal-footer">
                        <div className="row row-sm-offset">
                          <div className="col-md-6 multi-horizontal">
                            <button type="submit" className="btn btn-success">
                              Submit
                            </button>
                          </div>
                          <div className="col-md-6 multi-horizontal text-left">
                            <button
                              id=""
                              type="button"
                              className="btn btn-default closePopup"
                              data-dismiss="modal"
                            >
                              Close
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <div
              id="editInfoModal"
              className="modal fade"
              role="dialog"
              data-backdrop="static"
              data-keyboard="false"
            >
              <div className="modal-dialog modal-lg">
                <div className="modal-content">
                  <div className="modal-header">
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      // onClick={this.resetInfoModal.bind(this)}
                    >
                      &times;
                    </button>
                    <h4 className="modal-title text-center">
                      Edit Patient Information
                    </h4>
                  </div>

                  <form method="post" onSubmit={this.onSubmitInfo}>
                    <div
                      className="modal-body"
                      style={{ position: "relative" }}
                    >
                      {/* Full-modal loading overlay */}
                      {this.state.loadingEditModal && (
                        <div
                          className="modal-loading-overlay"
                          style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            background: "rgba(255,255,255,0.7)",
                            zIndex: 10,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <div
                            className="spinner-edit-modal"
                            style={{
                              width: 48,
                              height: 48,
                              border: "6px solid #f3f3f3",
                              borderTop: "6px solid #3498db",
                              borderRadius: "50%",
                              animation: "spin 1s linear infinite",
                            }}
                          ></div>
                          <style>{`@keyframes spin { 
                0% { transform: rotate(0deg); } 
                100% { transform: rotate(360deg); } 
              }`}</style>
                        </div>
                      )}

                      {/* Row 1: Name, Email, Phone */}
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>Name</label>
                            <input
                              type="text"
                              className="form-control"
                              name="patient_name"
                              onChange={this.onChange}
                              value={this.state.patient_name}
                            />
                          </div>
                        </div>

                        <div className="col-md-4">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>Email</label>
                            <input
                              type="text"
                              className="form-control"
                              name="email_id"
                              onChange={this.onChange}
                              value={this.state.email_id}
                            />
                          </div>
                        </div>

                        <div className="col-md-4">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>Phone</label>
                            <input
                              type="text"
                              className="form-control"
                              name="phone"
                              onChange={this.onChange}
                              value={this.state.phone}
                            />
                          </div>
                        </div>
                      </div>

                      {/* Row 2: Doctor Name, Hospital, IP/OP */}
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>
                              Hospital Name
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="hospital"
                              onChange={this.onChange}
                              value={this.state.hospital}
                            />
                          </div>
                        </div>

                        <div className="col-md-4">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>
                              Doctor Name
                            </label>
                            <Select
                              options={options}
                              value={selectedDoctor}
                              onChange={this.handleDoctorChange}
                              placeholder="Search Doctor"
                              classNamePrefix="react-select"
                              styles={{
                                control: (base) => ({
                                  ...base,
                                  borderColor: errors.doctor_id
                                    ? "red"
                                    : base.borderColor,
                                }),
                              }}
                            />
                          </div>
                        </div>

                        <div className="col-md-4">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>IP/OP</label>
                            <input
                              type="text"
                              className="form-control"
                              onChange={this.onIpOpChange}
                              value={this.state.ipop}
                            />
                          </div>
                        </div>
                      </div>

                      {/* Row 3: DOB + File Type + Confirmation */}
                      <div className="row">
                        {/* DOB */}
                        <div className="col-md-4">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>DOB</label>
                            <div className="input-group">
                              <Datetime
                                value={dob}
                                onChange={this.handleDateChange}
                                inputProps={{
                                  className: `form-control ${
                                    errors.dob ? "is-invalid" : ""
                                  }`,
                                  placeholder: "Select Date",
                                }}
                                dateFormat="MM/DD/YYYY"
                                timeFormat={false}
                              />
                              <span className="input-group-addon">
                                <span className="fa fa-calendar"></span>
                              </span>
                            </div>
                            {errors.dob && (
                              <div className="invalid-feedback">
                                {errors.dob}
                              </div>
                            )}
                          </div>
                        </div>

                        {/* File Type */}
                        <div className="col-md-4">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>File Type</label>
                            <select
                              className="form-control"
                              value={this.state.filetype}
                              onChange={this.handleTypeChange}
                            >
                              <option value="easy">Easy</option>
                              <option value="moderate">Moderate</option>
                              <option value="hard">Hard</option>
                            </select>
                          </div>
                        </div>

                        {/* Confirmation */}
                        <div className="col-md-4">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>
                              Confirmation
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              style={{
                                cursor: "pointer",
                                backgroundColor: "#fff",
                              }}
                              value={this.state.Confirmation}
                              readOnly
                              onClick={this.handleConfirmationClick}
                              placeholder="Select Confirmation"
                              data-toggle="modal"
                              data-target="#ConfirmInfoModal"
                            />
                          </div>
                        </div>
                      </div>

                      {/* Row 4: Priority, Report Status, Atrial Fib */}
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>Priority</label>
                            <select
                              className="form-control"
                              value={this.state.priority}
                              onChange={this.onPriorityChange}
                            >
                              <option value="4">NA</option>
                              <option value="1">1</option>
                              <option value="2">2</option>
                              <option value="3">3</option>
                              <option value="4">4</option>
                              <option value="5">5</option>
                            </select>
                          </div>
                        </div>

                        <div className="col-md-4">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>
                              Report Status
                            </label>
                            <select
                              className="form-control"
                              value={this.state.reportstatus}
                              onChange={this.onReportStatuschange}
                            >
                              <option value="0">Not Analayzed</option>
                              <option value="6">Analyze Completed</option>
                              <option value="3">Verification Completed</option>
                              <option value="4">In Preparation</option>
                              <option value="5">Report Completed</option>
                            </select>
                          </div>
                        </div>

                        <div className="col-md-4">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>
                              Atrial Fibrillation
                            </label>
                            <select
                              className="form-control"
                              value={this.state.af}
                              onChange={this.onChange}
                            >
                              <option value="">Choose</option>
                              <option value="yes">Yes</option>
                              <option value="no">No</option>
                            </select>
                          </div>
                        </div>
                      </div>

                      {/* Row 5: Indication, Duration, Gender */}
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>Indication</label>
                            <input
                              type="text"
                              className="form-control"
                              name="indication"
                              onChange={this.onChange}
                              value={this.state.indication}
                            />
                          </div>
                        </div>

                        <div className="col-md-4">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>
                              Monitoring Duration
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              onChange={this.onDurationChange}
                              value={this.state.duration}
                            />
                          </div>
                        </div>

                        <div className="col-md-4">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>Gender</label>
                            <select
                              className="form-control"
                              onChange={this.onGenderChange}
                              value={this.state.gender}
                            >
                              <option value="M">M</option>
                              <option value="F">F</option>
                            </select>
                          </div>
                        </div>
                      </div>

                      {/* Row 6: Issue Noticed, Cardiac Surgery, Pacemaker */}
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>
                              Issue Noticed
                            </label>
                            <select
                              className="form-control"
                              value={this.state.issueReport}
                              onChange={(e) =>
                                this.setState({ issueReport: e.target.value })
                              }
                            >
                              <option value="NA">Not Selected</option>
                              <option value="repeat">Repeat</option>
                              <option value="low_data">Low data</option>
                              <option value="customer_reject">
                                Customer Reject
                              </option>
                              <option value="battery_issue">
                                Battery Issue
                              </option>
                              <option value="device_issue">Device Issue</option>
                            </select>
                          </div>
                        </div>

                        <div className="col-md-4">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>
                              Cardiac Surgery/Interventions
                            </label>
                            <select
                              className="form-control"
                              value={this.state.cardiac_surgery}
                              onChange={this.onChange}
                            >
                              <option value="yes">Yes</option>
                              <option value="no">No</option>
                            </select>
                          </div>
                        </div>

                        <div className="col-md-4">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>Pacemaker</label>
                            <select
                              className="form-control"
                              value={this.state.pacemaker}
                              onChange={(e) => {
                                this.setState({
                                  pacemaker: e.target.value === "true",
                                });
                              }}
                            >
                              <option value="true">Yes</option>
                              <option value="false">No</option>
                            </select>
                          </div>
                        </div>
                      </div>
                      {/* Row 7: Support Person + Support Level + Supported Matter */}
                      <div className="row">
                        {/* Support Person Dropdown */}
                        {/* Support Person Dropdown */}
                        <div className="col-md-4">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>
                              Support Person
                            </label>
                            <select
                              className="form-control"
                              value={this.state.supportPerson}
                              onChange={(e) =>
                                console.log(e.target.value) ||
                                this.setState({ supportPerson: e.target.value })
                              }
                            >
                              <option value="">Select Person</option>
                              {this.state.supportPersons &&
                              this.state.supportPersons.length > 0 ? (
                                this.state.supportPersons.map((person) => (
                                  <option key={person._id} value={person._id}>
                                    {person.name}
                                  </option>
                                ))
                              ) : (
                                <option disabled>Loading...</option>
                              )}
                            </select>
                          </div>
                        </div>

                        {/* Support Level Dropdown */}
                        <div className="col-md-2">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>
                              Support Level
                            </label>
                            <select
                              className="form-control"
                              value={this.state.supportLevel}
                              onChange={(e) =>
                                console.log(e.target.value) ||
                                this.setState({ supportLevel: e.target.value })
                              }
                            >
                              <option value="">Select Level</option>
                              <option value="L0">L0</option>
                              <option value="L1">L1</option>
                              <option value="L2">L2</option>
                              <option value="L3">L3</option>
                            </select>
                          </div>
                        </div>

                        {/* Supported Matter Textarea */}
                        <div className="col-md-6">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>
                              Supported Matter
                            </label>
                            <textarea
                              className="form-control"
                              rows="3"
                              value={this.state.supportedMatter}
                              onChange={(e) =>
                                // console.log(e.target.value) ||
                                this.setState({
                                  supportedMatter: e.target.value,
                                })
                              }
                              placeholder="Enter details..."
                            />
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>
                              Prioritize Data
                            </label>
                            <select
                              className="form-control"
                              value={this.state.prioritizeData}
                              onChange={(e) =>
                                this.setState({
                                  prioritizeData: e.target.value,
                                })
                              }
                            >
                              <option value="No">No</option>
                              <option value="Yes">Yes</option>
                            </select>
                          </div>
                        </div>
                      </div>

                      {/* Row 9: Clinical Condition */}
                      <div className="row">
                        <div className="col-md-12">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>
                              Clinical Condition
                            </label>
                            <textarea
                              className="form-control"
                              rows="3"
                              value={this.state.clinicalCondition}
                              onChange={(e) =>
                                this.setState({
                                  clinicalCondition: e.target.value,
                                })
                              }
                              placeholder="Enter clinical condition..."
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Footer with separate divs for Submit and Close */}
                    <div className="modal-footer d-flex justify-content-center gap-3">
                      <button
                        type="submit"
                        className="btn btn-success"
                        disabled={this.state.loadingEditModal}
                      >
                        Submit
                      </button>

                      <button
                        type="button"
                        className="btn btn-default closePopup"
                        data-dismiss="modal"
                      >
                        Close
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div className="row" style={{ marginTop: "2.25%" }}>
              <div className="col-sm-12">
                <div
                  className="panel panel-default card-view"
                  style={{ marginTop: "-1%" }}
                >
                  <div className="panel-heading">
                    <div
                      className="pull-right"
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "center",
                        width: "100%",
                      }}
                    >
                      <input
                        type="text"
                        placeholder="Search patients..."
                        value={this.state.search}
                        onChange={this.handleSearch}
                        style={{
                          marginRight: "10px",
                          color: "black",
                          border: "none",
                          padding: "5px",
                          borderRadius: "4px",
                        }}
                      />

                      <select
                        onChange={this.handlePageSizeChange}
                        value={this.state.pageSize}
                        style={{
                          color: "black",
                          padding: "5px",
                          borderRadius: "4px",
                          backgroundColor: "white",
                        }}
                      >
                        <option value="50">50</option>
                        <option value="100">100</option>
                        <option value="500">500</option>
                        <option value="1500">1500</option>
                      </select>
                      <button
                        onClick={this.exportToCSV}
                        style={{
                          marginLeft: "10px",
                          padding: "10px",
                          backgroundColor: "#4CAF50",
                          color: "white",
                          border: "none",
                          borderRadius: "5px",
                        }}
                      >
                        Export to CSV
                      </button>
                    </div>

                    <div className="clearfix"></div>
                  </div>
                  <div className="panel-wrapper collapse in">
                    <div className="panel-body">
                      <div style={{ overflowX: "auto" }}>
                        <div style={{ overflowX: "auto" }}>
                          <table className="table">
                            <thead>
                              <tr>
                                <th onClick={() => this.handleSort("slno")}>
                                  SL NO
                                </th>
                                <th
                                  onClick={() => this.handleSort("device_id")}
                                >
                                  Patient ID
                                </th>
                                <th
                                  onClick={() => this.handleSort("patientName")}
                                >
                                  PATIENT NAME
                                </th>
                                <th onClick={() => this.handleSort("created")}>
                                  Created On
                                </th>
                                <th onClick={() => this.handleSort("phone")}>
                                  Phone
                                </th>
                                <th
                                  onClick={() => this.handleSort("doctorName")}
                                >
                                  Doctor
                                </th>
                                <th
                                  onClick={() => this.handleSort("serial_no")}
                                >
                                  Serial No
                                </th>
                                <th
                                  onClick={() => this.handleSort("serial_no")}
                                >
                                  Serial No
                                </th>

                                <th
                                  onClick={() =>
                                    this.handleSort("RecordingStatus")
                                  }
                                >
                                  Recording Status
                                </th>
                                <th
                                  onClick={() =>
                                    this.handleSort("customer_details")
                                  }
                                >
                                  Customer details
                                </th>
                                <th onClick={() => this.handleSort("hospital")}>
                                  Hospital
                                </th>
                                <th>Active Morning</th>
                                <th>Active Evening</th>
                                <th
                                  onClick={() =>
                                    this.handleSort("issuereported")
                                  }
                                >
                                  Issue Reported
                                </th>
                                <th
                                  onClick={() =>
                                    this.handleSort("BatteryPercentage")
                                  }
                                >
                                  Battery Percentage
                                </th>
                                <th onClick={() => this.handleSort("duration")}>
                                  Duration
                                </th>
                                <th onClick={() => this.handleSort("ip_op")}>
                                  IP/OP
                                </th>

                                <th onClick={() => this.handleSort("gender")}>
                                  Gender
                                </th>

                                <th onClick={() => this.handleSort("Trigger")}>
                                  Trigger
                                </th>

                                <th onClick={() => this.handleSort("Mac_id")}>
                                  Mac ID
                                </th>

                                <th onClick={() => this.handleSort("backup")}>
                                  Backup Status
                                </th>
                                <th onClick={() => this.handleSort("symptoms")}>
                                  Symptoms
                                </th>

                                <th onClick={() => this.handleSort("Trigger")}>
                                  Invert
                                </th>
                                <th onClick={() => this.handleSort("Status")}>
                                  Status
                                </th>
                                <th onClick={() => this.handleSort("action")}>
                                  Action
                                </th>
                                <th onClick={() => this.handleSort("diary")}>
                                  Diary
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {displayedRows.length > 0 ? (
                                displayedRows.map((row, index) => (
                                  <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>{row.device_id}</td>

                                    <td>{row.patientName}</td>
                                    <td>{row.created}</td>

                                    <td>{row.phone}</td>

                                    <td>{row.doctorName}</td>
                                    <td>{row.serial_no}</td>
                                    <td>{row.serial_no}</td>

                                    <td>{row.RecordingStatus}</td>

                                    <td>{row.customer_details}</td>
                                    <td>{row.hospital}</td>
                                    <td>{row.activeMorning}</td>
                                    <td>{row.activeEvening}</td>

                                    <td>{row.issuereported}</td>
                                    <td>{row.BatteryPercentage}</td>
                                    <td style={{ textAlign: "center" }}>
                                      {row.duration}
                                    </td>
                                    <td>{row.ip_op}</td>
                                    <td>{row.gender}</td>

                                    <td>{row.Trigger}</td>
                                    <td>{row.Mac_id}</td>
                                    <td>{row.backup}</td>
                                    <td>{row.symptoms}</td>
                                    <td>{row.Invert}</td>
                                    <td>{row.Status}</td>
                                    <td>{row.action}</td>
                                    <td>{row.diary}</td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td
                                    colSpan="22"
                                    style={{ textAlign: "center" }}
                                  >
                                    No data available
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <div className="pagination-container">
                        <button
                          className="btn btn-primary"
                          onClick={this.prevPage}
                          disabled={this.state.currentPage === 1}
                        >
                          Previous
                        </button>
                        <span className="current-page">
                          Page {this.state.currentPage} of{" "}
                          {this.state.totalPages}
                        </span>
                        <button
                          className="btn btn-primary"
                          onClick={this.nextPage}
                          // disabled={
                          //   this.state.currentPage === this.state.totalPages
                          // }
                        >
                          Next
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Modal
          isOpen={triggerModalOpen}
          onRequestClose={this.closeTriggerModal}
          contentLabel="Trigger Request"
          style={{
            overlay: {
              backgroundColor: "rgba(0, 0, 0, 0)",
              backdropFilter: "none",
              WebkitBackdropFilter: "none",
            },
            content: {
              top: "50%",
              left: "50%",
              right: "auto",
              bottom: "auto",
              transform: "translate(-50%, -50%)",
              color: "black",
              width: "28%",
              maxWidth: "420px",
              padding: "10px",
            },
          }}
        >
          <h2 style={{ color: "black", margin: "0 0 8px 0", fontSize: "20px" }}>
            {triggerType === "old" ? "Trigger Old" : "Trigger New"}
          </h2>
          <form onSubmit={this.submitTriggerRequest}>
            <div
              style={{
                display: "flex",
                gap: "12px",
                alignItems: "flex-start",
                marginBottom: "8px",
              }}
            >
              <div style={{ flex: 1 }}>
                <label style={{ color: "black", display: "block" }}>Web *</label>
                <select
                  name="triggerWeb"
                  value={triggerWeb}
                  onChange={this.handleTriggerInputChange}
                  className="form-control"
                  required
                >
                  <option value="">Select</option>
                  <option value="web1">web1</option>
                  <option value="web2">web2</option>
                  <option value="web4">web4</option>
                  <option value="web5">web5</option>
                </select>
                {triggerErrors.triggerWeb ? (
                  <small style={{ color: "red", display: "block", marginTop: "2px" }}>
                    {triggerErrors.triggerWeb}
                  </small>
                ) : null}
              </div>
              <div style={{ flex: 1 }}>
                <label style={{ color: "black", display: "block" }}>Patientid (Optional)</label>
                <input
                  type="text"
                  name="triggerPatientId"
                  value={triggerPatientId}
                  onChange={this.handleTriggerInputChange}
                  className="form-control"
                />
              </div>
            </div>
            <div style={{ display: "flex", gap: "8px", marginTop: "6px" }}>
              <button type="submit" className="btn btn-success">
                Submit
              </button>
              <button type="button" onClick={this.closeTriggerModal} className="btn btn-default">
                Close
              </button>
            </div>
          </form>
          {triggerOutput ? (
            <p style={{ color: "black", marginTop: "8px", marginBottom: "8px" }}>
              {String(triggerOutput)
                .split("\n")
                .map((item, key) => (
                  <span key={key}>
                    {item}
                    <br />
                  </span>
                ))}
            </p>
          ) : null}
        </Modal>
      </div>
    );
  }
}
class YourComponent extends Component {
  state = {
    showModal: false,
    batteryPercentage: null,
  };

  BatteryPercentageClicked = (e) => {
    var userid = e.currentTarget.id;
    axios
      .get(`${apiUrl}api/common/getbatterypercentage?userid=${userid}`)
      .then((res) => {
        console.log(res.data);
        this.setState({ batteryPercentage: res.data.output, showModal: true });
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };
  handleCloseModal = () => {
    this.setState({ showModal: false });
  };

  render() {
    const { patient } = this.props;
    const { showModal, batteryPercentage, currentPage, errors } = this.state;

    return (
      <>
        <button
          type="button"
          className="btn btn-danger"
          id={patient._id}
          onClick={this.BatteryPercentageClicked}
          style={{ marginLeft: "10px" }}
        >
          {patient.BatteryPercentage}%
        </button>

        <Modal
          isOpen={showModal}
          onRequestClose={this.handleCloseModal}
          contentLabel="Battery Percentage"
          style={{
            content: {
              color: "black",
              width: "50%",
              maxWidth: "800px",
              margin: "auto",
            },
          }}
        >
          <h2 style={{ color: "black" }}>Battery Percentage</h2>
          {batteryPercentage !== null ? (
            <p style={{ color: "black" }}>
              Battery percentage is:{" "}
              {batteryPercentage.split("\n").map((item, key) => {
                return (
                  <span key={key}>
                    {item}
                    <br />
                  </span>
                );
              })}
            </p>
          ) : (
            <p style={{ color: "black" }}>Loading...</p>
          )}
          <button onClick={this.handleCloseModal}></button>
        </Modal>
      </>
    );
  }
}
class Serialno extends Component {
  state = {
    showModal: false,
    serialno: null,
  };

  serialnoClicked = (e) => {
    console.log(e.currentTarget.id);
    var mac_id = e.currentTarget.id;

    axios
      .get(`${apiUrl}api/users/getSubsribe`, { params: { mac_id } })
      .then((res) => {
        console.log(res.data);
        this.setState({ serialno: res.data.data, showModal: true });
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  handleCloseModal = () => {
    this.setState({ showModal: false });
  };

  render() {
    const { patient } = this.props;
    const { showModal, serialno, currentPage, errors } = this.state;

    return (
      <>
        <button
          type="button"
          className="serialno_button"
          id={patient.Mac_id}
          onClick={this.serialnoClicked}
        >
          {patient.serial_no}
        </button>

        {serialno && (
          <Modal
            isOpen={showModal}
            onRequestClose={this.handleCloseModal}
            contentLabel="Records"
            style={{
              content: {
                color: "black",
                width: "60%",
                margin: "auto",
                marginTop: "6%",
              },
            }}
          >
            <h2 style={{ color: "black" }}>Records</h2>

            <p style={{ color: "black", fontSize: "15px" }}>
              {serialno
                .replace(/{"response":200}/g, "") // Remove {"response":200} from the string
                .split("\n")
                .map((item, key) => (
                  <span key={key}>
                    {item}
                    <br />
                    <br />
                  </span>
                ))}
            </p>
          </Modal>
        )}
      </>
    );
  }
}
class BackupButton extends Component {
  state = {
    backup: null,
  };
  backupClicked = (e) => {
    const userid = e.currentTarget.id;
    axios
      .post(`${apiUrl}api/common/ChangeBackupStatus`, {
        userid: userid,
      })
      .then((res) => {
        console.log("res.data" + res.data);
        this.setState({ backup: res.data });
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  render() {
    const { patient } = this.props;
    return (
      <button
        type="button"
        className="btn btn-danger mr-20"
        id={patient._id}
        onClick={this.backupClicked}
      >
        {patient.backup_status}
      </button>
    );
  }
}

export default PatientInfoWeb;
